import { useEffect, useState } from "react"
import { SimpleSelect } from "interfaces/dataInterfaces"
import Select, { SingleValue } from "react-select"
import { useAssociatedCountriesQuery } from "services/core/user"

interface CountrySelectorProps {
  onSelect?: (country?: SimpleSelect) => void
  label?: string
  className?: string
  allowAll?: boolean
  isClearable?: boolean
  value?: number
}

const SelectAll: any = { label: "All", value: 0 }

export default function AssociatedCountriesSelector({
  onSelect,
  label,
  className,
  allowAll = true,
  isClearable = true,
  value,
}: CountrySelectorProps) {
  const { data: countries, isFetching } = useAssociatedCountriesQuery()

  const [countriesList, setCountriesList] = useState<{ label: "All"; value: 0 }[]>([])

  const handleSelect = (event: SingleValue<{ value: number; label: string }>) => {
    if (onSelect) onSelect(event as any)
  }

  useEffect(() => {
    if (!countries?.length) return
    let associatedCountries = countries?.length > 1 && allowAll ? [SelectAll] : []
    associatedCountries = [
      ...associatedCountries,
      ...(countries?.map(c => ({ value: c.adm0Code, label: c.countryName })) || []),
    ]
    setCountriesList(associatedCountries)
    if (associatedCountries?.length === 1 && associatedCountries[0].value !== -1 && allowAll)
      handleSelect(associatedCountries[0])
  }, [countries])

  return (
    <>
      {label && <label className="wfp--label">{label}</label>}
      <Select
        isSearchable
        isClearable={isClearable}
        isLoading={isFetching}
        placeholder="Select country"
        className={className || "dropdown mr-4"}
        classNamePrefix="select"
        options={countriesList}
        onChange={event => handleSelect(event)}
        value={value ? countriesList?.find(country => country.value === value) : undefined}
      />
    </>
  )
}
